<template>
  <div>
    <h5>{{ company.CustomerCompanyName }}</h5>

    <dl class="company-details">
      <dt>Magic Number</dt>
      <dd>{{ company.CustomerCompanyMagicNumber || '-' }}</dd>
      <dt>Email adres</dt>
      <dd>{{ company.CustomerCompanyEmailAddress || '-' }}</dd>
      <dt>Telefoonnummer</dt>
      <dd>{{ company.CustomerCompanyPhoneNumber || '-' }}</dd>
      <dt>Po Id</dt>
      <dd data-qa="customer-company-id">
        {{ company.CustomerCompanyPoId || '-' }}
      </dd>
      <dt>Kvk nummer</dt>
      <dd>{{ company.CustomerCompanyChamberOfCommerceNumber || '-' }}</dd>
      <dt>Kvk locatienummer</dt>
      <dd>
        {{ company.CustomerCompanyChamberOfCommerceEstablishmentNumber || '-' }}
      </dd>
      <dt>Adres</dt>
      <dd>{{ company.CustomerCompanyAddress || '-' }}</dd>
      <dt>Postcode</dt>
      <dd>{{ company.CustomerCompanyZipcode || '-' }}</dd>
      <dt>Vestigingsplaats</dt>
      <dd>{{ company.CustomerCompanyCity || '-' }}</dd>
    </dl>
  </div>
</template>

<script>
export default {
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
}
</script>

<style lang="scss" scoped>
h5 {
  display: inline-block;
}

.company-details {
  display: grid;
  grid-template-columns: 1fr 2fr;
  margin-bottom: 1em;
}

.info-label {
  flex: 0 0 auto;
  background: $gray-lightest;
  margin-left: 1em;
  padding: 0.25em 0.5em;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
}

.icon-info-label {
  @include icon();

  margin-right: 0.25em;
}
</style>
